module.exports = __webpack_public_path__ + "static/media/amulet_02.a533d152.png";